import { Badge, Text, Tooltip } from '@lbcamden/lib-react';
import { ViewRiskFactorValue } from '@lbcamden/shared-utils';
import { FunctionComponent } from 'react';

import { InfoContainer, InfoHeading } from '../ResidentCard.styled';
import { Divider, RiskFactorsList, RiskFactorsListItem } from './RiskFactors.styled';

export type RiskFactorsProps = {
  riskFactors: ViewRiskFactorValue[];
};

export const RiskFactors: FunctionComponent<RiskFactorsProps> = ({ riskFactors }) => (
  <InfoContainer>
    <InfoHeading>
      Risk factors
      {!!riskFactors.length && (
        <Badge $bgColor="accent" $fontSize={12}>
          {riskFactors.length}
        </Badge>
      )}
    </InfoHeading>

    {riskFactors.length === 0 ? (
      <Text variant="body1">None</Text>
    ) : (
      <RiskFactorsList data-testid="risk-factors-list">
        {riskFactors.map((riskFactor, index) => [
          <li key={riskFactor.key}>
            <RiskFactorsListItem>
              {riskFactor.label || `[${riskFactor.key}]`}
              {riskFactor.tooltip ? <Tooltip content={riskFactor.tooltip} /> : ''}
            </RiskFactorsListItem>
          </li>,
          index !== riskFactors.length - 1 && <Divider key={`divider-${riskFactor.key}`} />,
        ])}
      </RiskFactorsList>
    )}
  </InfoContainer>
);
